module.exports = __webpack_public_path__ + "static/media/catoffline_small@2x.51acdf90.jpg";